import type { QuoteRequestStatus } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { QUOTE_STATUS_LABELS } from '@/entities/quote';
import { StatusBadge } from '@/shared/ui';
import { QUOTE_STATUS_TONES } from './quote-status-tones';

interface QuoteStatusListProps {
  readonly status: QuoteRequestStatus;
  /** 켜진 경고 라벨(activeQuoteWarnings) — 상품 숨김·삭제, 색상 공급 불가. */
  readonly warnings: readonly string[];
}

/** 견적 상태와 경고 배지를 한 줄로 — "견적 상태" 목록으로 읽힌다(상세 머리말). */
export const QuoteStatusList = ({ status, warnings }: QuoteStatusListProps): ReactElement => (
  <ul aria-label="견적 상태" className="flex flex-wrap items-center gap-1.5">
    <li>
      <StatusBadge tone={QUOTE_STATUS_TONES[status]}>
        {QUOTE_STATUS_LABELS[status].label}
      </StatusBadge>
    </li>
    {warnings.map((warning) => (
      <li key={warning}>
        <StatusBadge tone="danger">{warning}</StatusBadge>
      </li>
    ))}
  </ul>
);
